import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import JsonWorkspace from './components/JsonWorkspace';
import XmlEditor from './pages/XmlEditor';
import HtmlEditor from './pages/HtmlEditor';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/json" element={<JsonWorkspace />} />
          <Route path="/xml" element={<XmlEditor />} />
          <Route path="/html" element={<HtmlEditor />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
